export default __webpack_public_path__ + "media/AetherBenefitsModalHero.af7209c9f70fd525224f8dba94c6f022.svg";